/**
 * Cliente HTTP da visibilidade das marcações do sistema na mesa (E38.F2). // ux-neutrality:allow doc-comment
 *
 * Espelha `apps/api/runtime/case_workspace.py` (PATCH /analyses/{id}/markers) e // ux-neutrality:allow doc-comment
 * `apps/api/types/case_workspace.py` (SystemMarkersRequest/State). O perito // ux-neutrality:allow doc-comment
 * alterna na mesa se os marcadores por critério aparecem; o estado é persistido // ux-neutrality:allow doc-comment
 * por análise (default oculto) e o laudo o respeita — oculto = contestada limpa. // ux-neutrality:allow doc-comment
 */
import type { AxiosInstance } from 'axios';

export interface SystemMarkersStateData {
  show_system_markers: boolean;
}

/** PATCH: persiste a visibilidade das marcações do sistema de uma análise. */
export async function setSystemMarkers(
  client: AxiosInstance,
  caseId: string,
  analysisId: string,
  show: boolean,
): Promise<SystemMarkersStateData> {
  const { data } = await client.patch<SystemMarkersStateData>(
    `/casos/${caseId}/analyses/${analysisId}/markers`,
    { show },
  );
  return data;
}
